import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { skipWhile, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { Role, userType } from 'src/app/core/models/role';
import { IError } from 'src/app/core/models/error.model';
import { sharedDataService } from 'src/app/core/services/sharedData.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {
  returnUrl: string;
  rememberMe = false;
  sub: Subscription;
  error = {} as IError;
  isLoading = false;
  isStarting = true;
  forgotPass: boolean = false;
  resetPass: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private sharedData: sharedDataService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.sub = this.authService.isAuthenticated
      .pipe(
        skipWhile((value) => value === null),
        take(1)
      )
      .subscribe((authenticated) => {
        if (authenticated) {
          setTimeout(() => {
            this.navigate();
          }, 350);
        } else {
          this.isStarting = false;
        }
      });
  }

  ngOnInit(): void {
    console.log('LOGIN COMP');
  }

  /**
   * Navigates login component
   */
  navigate() {
    this.authService.LoggedinUser.pipe(
      skipWhile((value) => value === null),
      take(1)
    ).subscribe((user) => {
      if (user) {
        switch (user.role.name) {
          case Role.ROOT:
            this.returnUrl =
              this.activatedRoute.snapshot.queryParams['returnUrl'] || '/root';
            this.router.navigateByUrl(this.returnUrl);
            break;
          case Role.USER:
            user.role.type !== userType.SIMPLE
              ? this.router.navigateByUrl(
                  this.activatedRoute.snapshot.queryParams['returnUrl'] ||
                    '/dashboard'
                )
              : this.router.navigateByUrl(
                  this.activatedRoute.snapshot.queryParams['returnUrl'] ||
                    '/crop'
                );
            break;
          case Role.CUSTOMER:
            this.returnUrl =
              this.activatedRoute.snapshot.queryParams['returnUrl'] ||
              '/customer';
            this.router.navigateByUrl(this.returnUrl);
            break;
          case Role.MANAGER:
            this.returnUrl =
              this.activatedRoute.snapshot.queryParams['returnUrl'] ||
              '/manager';
            this.router.navigateByUrl(this.returnUrl);
            break;
          case Role.CLIENT:
            this.returnUrl =
              this.activatedRoute.snapshot.queryParams['returnUrl'] ||
              '/client';
            this.router.navigateByUrl(this.returnUrl);
            break;
        }
      }
    });
  }

  /**
   * Attempts to login
   * @param loginForm - NgForm with email and password
   * @returns
   */
  attemptToLogin(loginForm: NgForm) {
    if (loginForm.invalid) {
      return;
    }

    this.error.message = '';
    this.isLoading = true;

    const { userEmail, userPassword } = loginForm.value;

    this.authService.login(userEmail, userPassword, this.rememberMe).subscribe(
      (response) => {
        this.isLoading = false;
        this.navigate();
      },
      (err) => {
        if (err.errorCode === 4010002) {
          this.translate.get('global.deactivatedAccountInfo').subscribe((text) => {
            const error = err;
            error['message'] = text;
            this.error = error;
          });
        } else {
          this.error = err;
        }

        this.isLoading = false;
      }
    );
  }

  logout() {
    this.sharedData.appId = null;
    this.authService.logout();
  }

  sendToken(loginForm: NgForm) {
    if (loginForm.invalid) {
      return;
    }
    const { userEmail } = loginForm.value;

    this.authService.forgotPassword(userEmail).subscribe(
      (response) => {
        this.resetPass = true;
        this.toastr.success(
          'The token was successfully sent to the specified email'
        );
      },
      (err) => {
        this.error = err;
      }
    );
  }

  resetPassword(resetPassForm: NgForm) {
    if (resetPassForm.invalid) {
      return;
    }
    const { token, userPassword } = resetPassForm.value;

    this.authService.resetPassword(token, userPassword).subscribe(
      (response) => {
        this.toastr.success('You have successfully reset your password');
        this.resetPass = false;
        this.forgotPass = false;
      },
      (err) => {
        this.error = err;
      }
    );
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
